import { render, staticRenderFns } from "./StructurePage.vue?vue&type=template&id=94acf78e&scoped=true"
import script from "./StructurePage.vue?vue&type=script&lang=js"
export * from "./StructurePage.vue?vue&type=script&lang=js"
import style0 from "./StructurePage.vue?vue&type=style&index=0&id=94acf78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94acf78e",
  null
  
)

export default component.exports